var render = function () {
  var _vm$rider_default_dat, _vm$rider_default_dat2, _vm$rider_default_dat3, _vm$currentSubmission, _vm$rider_default_dat4, _vm$rider_default_dat5, _vm$rider_default_dat6, _vm$rider_default_dat7, _vm$rider_default_dat8, _vm$rider_default_dat9, _vm$rider_default_dat0, _vm$rider_default_dat1, _vm$rider_default_dat10, _vm$rider_default_dat11;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('PlayerInfo', {
    attrs: {
      "rider-data": _vm.rider_default_data,
      "genders": _vm.genders,
      "verification-status": _vm.verificationStatus
    }
  }), _c('TabNavigation', {
    attrs: {
      "is-active-profile-tab": _vm.isActiveProfileTab,
      "is-active-event-highlights-tab": _vm.isActiveEventHighlightsTab,
      "is-active-activity-tab": _vm.isActiveActivityTab,
      "is-active-in-game-shop-tab": _vm.isActiveInGameShopTab,
      "is-active-vault-rewards-tab": _vm.isActiveVaultRewardsTab,
      "show-game-shop": ((_vm$rider_default_dat = _vm.rider_default_data) === null || _vm$rider_default_dat === void 0 ? void 0 : _vm$rider_default_dat.user) && !((_vm$rider_default_dat2 = _vm.rider_default_data) !== null && _vm$rider_default_dat2 !== void 0 && (_vm$rider_default_dat3 = _vm$rider_default_dat2.user) !== null && _vm$rider_default_dat3 !== void 0 && _vm$rider_default_dat3.isKid)
    },
    on: {
      "tab-changed": _vm.makeTabFunc
    }
  }), _c('WeightSubmissionModal', {
    attrs: {
      "show": _vm.showWeightModal,
      "submission-type": ((_vm$currentSubmission = _vm.currentSubmissionData) === null || _vm$currentSubmission === void 0 ? void 0 : _vm$currentSubmission.type) || 'pre_weight',
      "event-data": _vm.currentSubmissionData || {}
    },
    on: {
      "submit": _vm.handleWeightModalSubmit,
      "close": _vm.handleWeightModalClose
    }
  }), _vm._l(_vm.weightSubmissions, function (submission, index) {
    return _c('WeightSubmissionAlert', {
      key: ("weight-alert-" + (submission.event_id) + "-" + (submission.type) + "-" + index),
      attrs: {
        "show": true,
        "title": _vm.getAlertTitle(submission),
        "start-time": submission.start_time_ms || submission.start_time,
        "end-time": submission.end_time_ms || submission.end_time || new Date(Date.now() + 24 * 60 * 60 * 1000),
        "button-text": 'Submit'
      },
      on: {
        "submit": function ($event) {
          return _vm.handleWeightSubmit(submission);
        },
        "expired": function ($event) {
          return _vm.handleWeightExpired(submission);
        }
      }
    });
  }), _vm.showVerificationAlert && _vm.isDataLoaded ? _c('VerificationAlert', {
    attrs: {
      "status": _vm.verificationStatus,
      "message": _vm.verificationMessage,
      "button-text": _vm.verificationButtonText,
      "button-route": _vm.verificationButtonRoute
    },
    on: {
      "dismiss": _vm.handleAlertDismiss
    }
  }) : _vm._e(), _c('section', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "container main-tab-container p-0"
  }, [_c('div', {
    staticClass: "tab-content-wrpr"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "nav-tabContent"
    }
  }, [_c('OverView', {
    attrs: {
      "is-active": _vm.isActiveProfileTab,
      "third-party-data": (_vm$rider_default_dat4 = _vm.rider_default_data) === null || _vm$rider_default_dat4 === void 0 ? void 0 : _vm$rider_default_dat4.third_party_data,
      "user-data": (_vm$rider_default_dat5 = _vm.rider_default_data) === null || _vm$rider_default_dat5 === void 0 ? void 0 : (_vm$rider_default_dat6 = _vm$rider_default_dat5.user) === null || _vm$rider_default_dat6 === void 0 ? void 0 : _vm$rider_default_dat6.userData,
      "total-events": _vm.user_total_event_count
    }
  }), _c('EventHighlights', {
    attrs: {
      "is-active": _vm.isActiveEventHighlightsTab,
      "gems-balance": _vm.userGems
    },
    on: {
      "buy-gems": _vm.handleBuyGems
    }
  }), _c('div', {
    staticClass: "tab-pane fade",
    class: {
      'show active': _vm.isActiveActivityTab
    },
    attrs: {
      "id": "nav-activities",
      "role": "tabpanel",
      "aria-labelledby": "nav-activities-tab",
      "tabindex": "1"
    }
  }, [!_vm.showDetail ? _c('div', [_c('PowerCurves', {
    attrs: {
      "chart-data-default": _vm.chartDataDefault,
      "chart-options": _vm.chartOptions,
      "chart-data-weight-per-kg": _vm.chartDataWeightPerKg,
      "chart-options-weight-per-kg": _vm.chartOptionsWeightPerKg,
      "first-graph-date": _vm.firstGraphDate,
      "second-graph-date": _vm.secondGraphDate,
      "tab-title": _vm.tabTitle
    },
    on: {
      "tab-selected": _vm.selectTab
    }
  }), _c('ActivityFilters', {
    attrs: {
      "type": _vm.type,
      "sortDate": _vm.sortDate
    },
    on: {
      "update:type": function (val) {
        return _vm.type = val;
      },
      "update:sortDate": function (val) {
        return _vm.sortDate = val;
      }
    }
  }), _vm.activities.results.length > 0 ? _c('ActivityList', {
    attrs: {
      "activities": _vm.activities,
      "genders": _vm.genders,
      "rider-data": _vm.rider_default_data,
      "graph-file-ids": _vm.graphFileIds,
      "finished": _vm.finished
    },
    on: {
      "view-activity": _vm.getSingleActivity,
      "download-file": _vm.downloadFile,
      "add-to-graph": _vm.addToGraph,
      "load-more": _vm.getAllActivities
    }
  }) : _c('div', [_c('div', {
    staticClass: "msg-txt"
  }, [_c('p', [_vm._v("- All your activities will be displayed here -")])])])], 1) : _vm._e(), _vm.showDetail ? _c('ActivityDetail', {
    attrs: {
      "single-ride-data": _vm.single_ride_data,
      "rider-data": _vm.rider_default_data,
      "genders": _vm.genders,
      "selected-date": _vm.selectedDate,
      "selected-file-id": _vm.selectedFileId,
      "chart-options-elevation": _vm.chartOptionsElevation,
      "chart-data-elevation": _vm.chartDataElevation,
      "chart-options-power": _vm.chartOptionsPower,
      "chart-data-power": _vm.chartDataPower,
      "chart-options-speed": _vm.chartOptionsSpeed,
      "chart-data-speed": _vm.chartDataSpeed,
      "chart-options-heart-rate": _vm.chartOptionsHeartRate,
      "chart-data-heart-rate": _vm.chartDataHeartRate,
      "chart-options-cadence": _vm.chartOptionsCadence,
      "chart-data-cadence": _vm.chartDataCadence,
      "hover-elevation-date": _vm.hoverElevationDate,
      "hover-elevation-time": _vm.hoverElevationTime,
      "hover-elevation": _vm.hoverElevation,
      "hover-power": _vm.hoverPower,
      "hover-speed": _vm.hoverSpeed,
      "hover-heart-rate": _vm.hoverHeartRate,
      "hover-cadence": _vm.hoverCadence,
      "avg-power": _vm.avgPower,
      "min-power": _vm.minPower,
      "max-power": _vm.maxPower,
      "avg-speed": _vm.avgSpeed,
      "max-speed": _vm.maxSpeed,
      "avg-heart-rate": _vm.avgHeartRate,
      "max-heart-rate": _vm.maxHeartRate,
      "min-heart-rate": _vm.minHeartRate,
      "avg-cadence": _vm.avgCadence,
      "max-cadence": _vm.maxCadence
    },
    on: {
      "hide-detail": _vm.hideDetail,
      "download-file": _vm.downloadFile
    }
  }) : _vm._e()], 1), (_vm$rider_default_dat7 = _vm.rider_default_data) !== null && _vm$rider_default_dat7 !== void 0 && _vm$rider_default_dat7.user && !((_vm$rider_default_dat8 = _vm.rider_default_data) !== null && _vm$rider_default_dat8 !== void 0 && (_vm$rider_default_dat9 = _vm$rider_default_dat8.user) !== null && _vm$rider_default_dat9 !== void 0 && _vm$rider_default_dat9.isKid) ? _c('GameShop', {
    ref: "gameShop",
    attrs: {
      "is-active": _vm.isActiveInGameShopTab,
      "user-gems": (_vm$rider_default_dat0 = _vm.rider_default_data) === null || _vm$rider_default_dat0 === void 0 ? void 0 : (_vm$rider_default_dat1 = _vm$rider_default_dat0.user) === null || _vm$rider_default_dat1 === void 0 ? void 0 : _vm$rider_default_dat1.userData['data']['PlayerData']['PlayerPersonalStruct']['Gems'],
      "user-coins": (_vm$rider_default_dat10 = _vm.rider_default_data) === null || _vm$rider_default_dat10 === void 0 ? void 0 : (_vm$rider_default_dat11 = _vm$rider_default_dat10.user) === null || _vm$rider_default_dat11 === void 0 ? void 0 : _vm$rider_default_dat11.userData['data']['PlayerData']['PlayerPersonalStruct']['Coins']
    }
  }) : _vm._e(), _c('VaultRewards', {
    attrs: {
      "is-active": _vm.isActiveVaultRewardsTab
    }
  })], 1)])])])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }